
import { Component, Vue } from "vue-property-decorator";
import { PFormInputTextSearch } from "@/common/components";
import { EventBus } from "@/event-bus";

@Component({
  name: "machine-search-filter",
  components: {
    PFormInputTextSearch,
  },
})
export class MachineSearchFilter extends Vue {
  search = "";
  machine_name = "";

  setSearch(text: string): void {
    this.search = text;
  }

  searchCenter(): void {
    EventBus.$emit("search-machine", this.search);
  }
}

export default MachineSearchFilter;
